'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.waveforms.list', [])
  .controller('WaveformsListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/waveforms/list/index.js